import { render, staticRenderFns } from "./ImgBox.vue?vue&type=template&id=b9781792&scoped=true&"
import script from "./ImgBox.vue?vue&type=script&lang=js&"
export * from "./ImgBox.vue?vue&type=script&lang=js&"
import style0 from "./ImgBox.vue?vue&type=style&index=0&id=b9781792&lang=less&scoped=true&"
import style1 from "./ImgBox.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9781792",
  null
  
)

export default component.exports